<template>
  <sc-page-base
    title="Grupos de produtos"
    :loading="loading">
    <div class="columns">
      <div class="column">
        <router-link
          class="button is-primary"
          :to="{ name: 'product-group-manage'}">
          Adicionar grupo de produtos
        </router-link>
      </div>
    </div>

    <sc-grid
      :data="productGroups"
      :total="productGroups.length"
      @submit="getProductGroups"
      default-sort-column="id"
      default-sort-direction="desc"
      :default-filters="defaultFilters"
      :has-backend-sorting="false">
      <template slot="filters" slot-scope="{ filters }">
        <div class="columns">
          <div class="column is-narrow">
            <sc-field
              label="Pesquisa por Sku">
              <sc-input
                v-model="filters.sku"
                placeholder="Digite um SKU"/>
            </sc-field>
          </div>
        </div>
      </template>

      <template slot="table-columns" slot-scope="{ props }">
        <sc-table-column
          field="id"
          label="ID"
          width="80"
          sortable>
          {{ props.row.id }}
        </sc-table-column>

        <sc-table-column
          field="name"
          label="Nome"
          :centered="false"
          sortable>
          {{ props.row.name }}
        </sc-table-column>

        <sc-table-column
          label="Sku">
          <span>
            {{ transformSkus(props.row) }}
          </span>
        </sc-table-column>

        <sc-table-column
          label="Ações"
          width="150">
          <div class="buttons has-addons">
            <router-link
              class="button is-primary"
              :to="{
              name: 'product-group-manage',
              params: { id: props.row.id }}">
              Editar
            </router-link>
            <sc-button
              theme="danger"
              text="Deletar"
              @click="deleteGroup(props.row)"/>
          </div>
        </sc-table-column>
      </template>
    </sc-grid>
  </sc-page-base>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
import {
   ScPageBase,
   ScInput,
   ScGrid,
   ScField,
   ScTableColumn,
   ScTable,
   ScButton,
  } from '@intelipost-js/secure-components';

const { mapState, mapActions } = createNamespacedHelpers('quote/productGroups');

export default {
  name: 'page-product-groups',
  data() {
    return {
      defaultFilters: {
        sku: '',
      },
    };
  },
  computed: {
    ...mapState([
      'loading',
      'productGroups',
    ]),
  },
  methods: {
    ...mapActions([
      'getProductGroups',
      'deleteGroup',
    ]),
    transformSkus(row) {
      const totalSkus = 10;
      const {
        skus = [],
      } = row;
      const skusFiltered = skus
        .filter((sku, index) => index < totalSkus)
        .join(', ');

      return `${skusFiltered} ${skus.length > totalSkus ? '...' : ''}`;
    },
  },
  beforeMount() {
    this.getProductGroups();
  },
  components: {
    ScPageBase,
    ScInput,
    ScGrid,
    ScField,
    ScTableColumn,
    ScTable,
    ScButton,
  },
};
</script>



// WEBPACK FOOTER //
// node_modules/@intelipost-modules/secure-quote/features/product-groups/PageProductGroups.vue?105208d2